const directory_regex = /(\w+)\/\w+\.jpg$/;
const context = require.context('.', true, /\.jpg$/);
const galleries = context.keys().reduce((galleries, file) => {
    const [, gallery] = directory_regex.exec(file);

    if (!galleries[gallery]) galleries[gallery] = { thumbnails: [], fullsize: [] };
    galleries[gallery][file.indexOf('_thumb') !== -1 ? 'thumbnails' : 'fullsize'].push(
        context(file)
    );
    return galleries;
}, {});

export default galleries;



// WEBPACK FOOTER //
// ./src/core/images/galleries/index.js